<template>
  <div class="deal_process">

    <div class="content_w site_content" :style="{background:`url('${tradeFlowPic}') 0 center / contain no-repeat`}"/>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {

  computed:{
    ...mapGetters(['oss_pub_domain']),
    tradeFlowPic(){
      return require('@/assets/images/trade-flow.png')
    }
  },


}
</script>

<style lang="scss" scoped>
.content_w{
  height: 180px;
  margin:  0 0 20px 0;
}

</style>
